import React, { FC } from "react";
import { Badge, COLOR as BADGE_COLOR, HIERARCHY } from "baseui/badge";
import { Link } from "kanopi-components/Link";
import { navigate } from "@reach/router";
import { QuoteState } from "kw/api/zeus";
import { TableBuilder } from "kanopi-components/TableView/TableView";
import { useFormatter } from "kw/util/useFormatter";

type TAdminQuotesSection = {
  quotes: TQuote[];
};
export const AdminQuotesSection: FC<TAdminQuotesSection> = ({ quotes }) => {
  const { formatDate, formatCurrency } = useFormatter();
  const statusColorMap = {
    [QuoteState.DRAFT]: BADGE_COLOR.warning,
    [QuoteState.SUBMITTED]: BADGE_COLOR.positive,
    [QuoteState.KNOCKOUT]: BADGE_COLOR.negative,
    [QuoteState.QUOTED]: BADGE_COLOR.positive,
    [QuoteState.ACCEPTED]: BADGE_COLOR.positive,
    [QuoteState.DISCARDED]: BADGE_COLOR.negative,
    [QuoteState.REFERRED]: BADGE_COLOR.warning,
  };

  const columnSchema = [
    {
      header: "Quote ID",
      id: "quoteId",
      children: (row: TQuote) => (
        <Link
          onClick={() => navigate(`/admin/quotes/${row.id}`)}
          data-testid={`customerQuote-${row.id}`}
        >
          {row.id}
        </Link>
      ),
      sortable: false,
    },
    {
      header: "Start date",
      id: "startDate",
      children: (row) => <>{formatDate(row?.startDate)}</>,
      sortable: false,
    },
    {
      header: "Finish date",
      id: "finishDate",
      children: (row) => <>{formatDate(row?.finishDate)}</>,
      sortable: false,
    },
    {
      header: "Premium",
      id: "premium",
      children: (row) => <>{formatCurrency(row.amountDue)}</>,
      sortable: false,
    },
    {
      header: "Status",
      id: "status",
      overrides: {
        TableHeadCell: {
          style: () => ({
            textAlign: "right",
          }),
        },
        TableBodyCell: {
          style: () => ({
            textAlign: "right",
          }),
        },
      },
      children: (row) => (
        <Badge
          hierarchy={HIERARCHY.secondary}
          color={statusColorMap[row.state] || BADGE_COLOR.accent}
          content={row.stateDisplay}
        />
      ),
      sortable: false,
    },
  ];
  return (
    <TableBuilder
      columnSchema={columnSchema}
      data={quotes}
      showSearchSection={false}
      showPagination={false}
      emptyMessage="No quotes found."
      data-testid="tableView-QUOTE"
    />
  );
};
